import { WithStyles, withStyles } from '@mui/styles';
import { FilterModel, SortModel } from '@tassat/common-definitions';
import { RouteComponentProps } from 'react-router-dom';

import { AdminUserDetails } from './adminUserDetails';
import { muiStyles } from './adminUserDetailsStyles';

type RouteParams = {
    userId: string;
};

export interface AdminUserDetailsProps extends RouteComponentProps<RouteParams>, WithStyles<typeof muiStyles> {
    editAdminUser: (adminUser: any, deleteUserValidationFunc: any) => void;
    filterModel: { string: FilterModel };
    sortModel: SortModel[];
    isSSOEnabled: boolean;
}

export default withStyles(muiStyles)(AdminUserDetails);